import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '@/components/ui/card'
import Image from 'next/image'
import Link from 'next/link'
import { FaLinkedin, FaNewspaper, FaQuoteLeft, FaQuoteRight, FaTwitter } from 'react-icons/fa'
import { Flex } from '../ui/flex'
import { Article } from './lb/lb-press-articles'

interface PressArticleCardProps {
  article: Article
  lang?: string
  className?: string
  isLink?: boolean
}

const TypeIcon = ({ type }: { type: string }) => {
  switch (type) {
    case 'Article web':
      return <FaNewspaper className='mr-1.5 h-3 w-3' />
    case 'Publication sur Twitter':
      return <FaTwitter className='mr-1.5 h-3 w-3' />
    case 'Publication sur LinkedIn':
      return <FaLinkedin className='mr-1.5 h-3 w-3' />
    case 'Publication sur X':
      return <FaTwitter className='mr-1.5 h-3 w-3' />
    default:
      return null
  }
}

export function PressArticleCard({
  article,
  lang = 'fr-FR',
  className = '',
  isLink = true
}: PressArticleCardProps) {
  const cardContent = (
    <Card className='flex h-full flex-col'>
      <CardHeader>
        <div className='flex items-start gap-2 pt-1 text-xs'>
          <Flex className='flex-nowrap items-center gap-2'>
            <Image
              src={article.logo_url}
              alt={`Logo ${article.media}`}
              width={16}
              height={20}
              className='h-4 w-4 object-contain'
            />
            <span>
              {article.media}
            </span>
          </Flex>
          <span className='grow' />
          <span className='whitespace-nowrap'>
            {new Date(article.date).toLocaleDateString(lang, {
              year: 'numeric',
              month: 'numeric',
              day: 'numeric'
            })}
          </span>
        </div>
        <CardTitle className='mt-1 text-lg font-semibold leading-tight'>
          {article.titre}
        </CardTitle>
      </CardHeader>
      <CardContent className='flex grow flex-col justify-end'>
        <blockquote className='relative border-l-4 border-primary py-2 pl-8 pr-4 italic'>
          <FaQuoteLeft className='absolute left-2 top-0 text-xl text-primary opacity-50' />
          <p className='text-sm line-clamp-6'>{article.citation}</p>
          <FaQuoteRight className='absolute -right-0 bottom-0 text-xl text-primary opacity-50' />
        </blockquote>
      </CardContent>
      <CardFooter className='justify-end pt-4'>
        <span className='mx-2 mb-2 inline-flex items-center rounded-full bg-muted px-3 py-1 text-xs font-medium text-primary'>
          <TypeIcon type={article.type} />
          {article.type}
        </span>
      </CardFooter>
    </Card>
  )

  if (isLink) {
    return (
      <Link
        href={article.url}
        target='_blank'
        rel='noopener noreferrer'
        className={`flex h-full flex-col rounded-lg border border-gray-200 bg-white shadow-sm transition-all duration-200 ease-in-out hover:-translate-y-1 hover:shadow-md ${className}`}
      >
        {cardContent}
      </Link>
    )
  }

  return (
    <a
      href={article.url}
      target='_blank'
      rel='noopener noreferrer'
      className={`flex h-full flex-col rounded-lg border border-gray-200 bg-white shadow-sm transition-all duration-200 ease-in-out hover:-translate-y-1 hover:shadow-md ${className}`}
    >
      {cardContent}
    </a>
  )
}
